/**
 * Resolve visible ticket types from the selected date set.
 *
 * @param {Object} options
 * @param {PublicEventResource.PublicEventResource[]} [options.selectedDates]
 * @param {PublicEventResource.PublicEventResource[]} [options.dayShows]
 * @param {PublicEventResource.PublicEventResource} [options.fallbackSource]
 * @param {boolean} [options.forceReservedUnavailable]
 * @return {{availabilitySource: (PublicEventResource.PublicEventResource|Object|undefined), isGeneralAdmissionAvailable: boolean, isReservedAvailable: boolean}}
 */
function resolveTicketTypeAvailability({
                                           selectedDates = [],
                                           dayShows = [],
                                           fallbackSource = undefined,
                                           forceReservedUnavailable = false,
                                       }) {
    const normalizedSelectedDates = Array.isArray(selectedDates)
        ? selectedDates.filter(Boolean)
        : [];

    if (normalizedSelectedDates.length > 0) {
        const isGeneralAdmissionAvailable = normalizedSelectedDates.every(eventDate => {
            return eventDate.hasGeneralAdmissionTicketTypesAvailable === true;
        });
        const isReservedAvailable = forceReservedUnavailable === false && normalizedSelectedDates.every(eventDate => {
            return eventDate.hasReservedTicketTypesAvailable === true;
        });

        return {
            availabilitySource: {
                ...normalizedSelectedDates[0],
                hasGeneralAdmissionTicketTypesAvailable: isGeneralAdmissionAvailable,
                hasReservedTicketTypesAvailable: isReservedAvailable,
            },
            isGeneralAdmissionAvailable,
            isReservedAvailable,
        };
    }

    const normalizedDayShows = Array.isArray(dayShows)
        ? dayShows.filter(Boolean)
        : [];
    const availabilitySource = normalizedDayShows.find(dayShow => {
        return dayShow.hasGeneralAdmissionTicketTypesAvailable === true ||
            dayShow.hasReservedTicketTypesAvailable === true;
    }) || normalizedDayShows[0] || fallbackSource;

    const isGeneralAdmissionAvailable = availabilitySource?.hasGeneralAdmissionTicketTypesAvailable === true;
    const isReservedAvailable = forceReservedUnavailable === false &&
        availabilitySource?.hasReservedTicketTypesAvailable === true;

    return {
        availabilitySource,
        isGeneralAdmissionAvailable,
        isReservedAvailable,
    };
}

export {resolveTicketTypeAvailability};
